import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";
import {
  deleteOverviewSaver,
  editOverviewSaver,
  getOverviewSavers,
  postOverviewSaver
} from "../actions/overviewSavers";

const initialState = {
  error: false,
  isLoadingGetOverviewSavers: false,
  overviewSavers: [],
  isLoadingSaveOverviewSavers: false,
  isLoadingDeleteOverviewSavers: false,
  isLoadingEditOverviewSavers: false
};

const overviewSaversSlice = createSlice({
  name: "overviewSavers",
  initialState,
  reducers: {
    "account/logoutUser": () => initialState
  },
  extraReducers: {
    [postOverviewSaver.pending]: (state) => {
      state.isLoadingSaveOverviewSavers = true;
      state.error = false;
    },
    [postOverviewSaver.fulfilled]: (state) => {
      state.isLoadingSaveOverviewSavers = false;
      state.error = false;
    },
    [postOverviewSaver.rejected]: (state) => {
      state.isLoadingSaveOverviewSavers = false;
      state.error = true;
    },
    [getOverviewSavers.pending]: (state) => {
      state.isLoadingGetOverviewSavers = true;
      state.error = false;
    },
    [getOverviewSavers.fulfilled]: (state, action) => {
      state.isLoadingGetOverviewSavers = false;
      state.overviewSavers = action?.payload?.data;
      state.error = false;
    },
    [getOverviewSavers.rejected]: (state) => {
      state.isLoadingGetOverviewSavers = false;
      state.error = true;
    },
    [editOverviewSaver.pending]: (state) => {
      state.isLoadingEditOverviewSavers = true;
      state.error = false;
    },
    [editOverviewSaver.fulfilled]: (state) => {
      state.isLoadingEditOverviewSavers = false;
      state.error = false;
    },
    [editOverviewSaver.rejected]: (state) => {
      state.isLoadingEditOverviewSavers = false;
      state.error = true;
    },
    [deleteOverviewSaver.pending]: (state) => {
      state.isLoadingDeleteOverviewSavers = true;
      state.error = false;
    },
    [deleteOverviewSaver.fulfilled]: (state) => {
      state.isLoadingDeleteOverviewSavers = false;
      state.error = false;
    },
    [deleteOverviewSaver.rejected]: (state) => {
      state.isLoadingDeleteOverviewSavers = false;
      state.error = true;
    },
    [logoutUser.fulfilled]: () => initialState,
    [logoutUser.rejected]: () => initialState
  }
});

export const getOverviewSaversError = (state) => state?.overviewSavers?.error;
export const getIsLoadingOverviewSavers = (state) => state?.overviewSavers?.isLoadingGetOverviewSavers || false;
export const getOverviewSaversData = (state) => state?.overviewSavers?.overviewSavers || [];
export const getIsLoadingSaveOverviewSavers = (state) => state?.overviewSavers?.isLoadingSaveOverviewSavers || false;
export const getIsLoadingDeleteOverviewSavers = (state) => state?.overviewSavers?.isLoadingDeleteOverviewSavers || false;
export const getIsLoadingEditOverviewSavers = (state) => state?.overviewSavers?.isLoadingEditOverviewSavers || false;

export default overviewSaversSlice;
